// eslint-disable-next-line
export default window.initialState ? window.initialState.endpoint : 'fake-route'
